module.exports = __webpack_public_path__ + "static/media/CardCompGreen.d0becf1a.png";